import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './locales/en.json';
import translationAR from './locales/ar.json';
import translationTE from './locales/te.json';
import translationTA from './locales/ta.json';
import translationKN from './locales/kn.json';
import translationHI from './locales/hi.json';
import translationSA from './locales/sa.json';

const resources = {
    en: {
        translation: translationEN
    },
    ar: {
        translation: translationAR
    },
    te: {
        translation: translationTE
    },
    ta: {
        translation: translationTA
    },
    kn: {
        translation: translationKN
    },
    hi: {
        translation: translationHI
    },
    sa: {
        translation: translationSA
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        debug: false,
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage']
        }
    });


export default i18n;
